import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch, Redirect } from "react-router-dom";
import { Security, LoginCallback, SecureRoute } from "@okta/okta-react";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import { ConnectedRouter } from "connected-react-router";
import configureStore, { history } from "store";

import App from "containers/App";
import Home from "containers/Home";

import { isActiveLink, links, loadIntlMessages } from "utils";
import { CALLBACK_PATH, OKTA_CONFIG } from "common";

// create the redux store with middlewares, e.g. redux-saga.
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider {...loadIntlMessages()}>
      <ConnectedRouter history={history}>
        <Security {...OKTA_CONFIG}>
          <Route path={CALLBACK_PATH} component={LoginCallback} />
          <Route
            render={({ location }) => (
              <App
                isActiveLink={isActiveLink}
                links={links}
                location={location}
                render={() => (
                  <Switch>
                    <Route
                      exact={true}
                      path="/"
                      render={() => <Redirect to="/apexonline" />}
                    />
                    <SecureRoute path="/apexonline" component={Home} />
                  </Switch>
                )}
              />
            )}
          />
        </Security>
      </ConnectedRouter>
    </IntlProvider>
  </Provider>,
  document.getElementById("root")
);
